module.exports = __webpack_public_path__ + "fonts/Calibre-ThinItalic.dd10d58f.woff2";